import { IFontFamily } from '../types';

export const fontFamily: IFontFamily = {
  primary: '"Flame", sans-serif',
  secondary: '"Flame Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
};
